<script>
export default {
    data() {
        return {
            items: {},
            loading: false
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.dashboard.classical.timeline"))
                .then((r) => this.items = r.data.timeline)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        getItemsByDate(dt) {
            let sessions = []
            let vm = this

            this.items.forEach(function(item) {
                let examDt = vm.moment(item.exam_time_start)
                let sessionDt = vm.moment(item.session_time_start)

                // check exams
                if (dt.isSame(examDt,'date')) {
                    sessions.push({
                        type: 'exam',
                        name: _.replace(item.name, 'Sesi: ', '')
                    })
                }
                // check session
                if (dt.isSame(sessionDt, 'date')) {
                    sessions.push({
                        type: 'session',
                        name: _.replace(item.name, 'Sesi: ', '')
                    })
                }
            })

            return sessions
        }
    }
}
</script>
<template>
    <a-card size="small" type="inner">
        <a-skeleton :loading="loading" active>
            <a-calendar>
                <ul slot="dateCellRender" slot-scope="value" class="events">
                    <li v-for="event in getItemsByDate(value)" :key="event.type + '-' + event.name">
                        <template v-if="event.type === 'session'">
                            <a-icon type="solution" /> {{ event.name }}
                        </template>
                        <template v-else>
                            <strong><a-icon type="audit" /> {{ event.name }}</strong>
                        </template>
                    </li>
                </ul>
            </a-calendar>
        </a-skeleton>
    </a-card>
</template>

<style scoped>
.events {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 12px !important;
}
</style>
